__turbopack_context__.v({
  "footerNavigation": "_1GEUja_footerNavigation",
  "footerWrapper": "_1GEUja_footerWrapper",
  "mainBlock": "_1GEUja_mainBlock",
});
